import { DailyNetworkStats } from '@daily-co/daily-js';
import {
  useLocalSessionId,
  useParticipantProperty,
} from '@daily-co/daily-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useDisplayName = (
  sessionId: string,
  showNames: boolean,
  network?: DailyNetworkStats['threshold'],
  name?: string
): string => {
  const { t } = useTranslation();
  const localSessionId = useLocalSessionId();
  const isLocal = sessionId === localSessionId;
  const userName = useParticipantProperty(sessionId, 'user_name');

  const hasPoorConnection = network === 'very-low' && isLocal;
  const hasWeakConnection = network === 'low' && isLocal;

  return useMemo(() => {
    if (!showNames) return '';
    if (name) return name;

    const displayName =
      userName || (isLocal ? t('people.you') : t('people.guest'));

    if (hasPoorConnection) {
      return t('people.usernamePoorCoonection', {
        displayName,
      });
    }
    if (hasWeakConnection) {
      return t('people.usernameWeakNetwork', {
        displayName,
      });
    }
    if (isLocal) {
      return t('people.youWithName', {
        displayName: userName || t('people.guest'),
      });
    }
    return displayName;
  }, [
    hasPoorConnection,
    hasWeakConnection,
    isLocal,
    name,
    showNames,
    t,
    userName,
  ]);
};
